import { MAIN_PAGE } from "./routes";

export const NAV_ITEMS_DROPDOWN = [
  {
    key: "trade",
    to: MAIN_PAGE,
    textKey: "common.trade",
    authRequired: true,
    isDisabled: false,
    icon: "trading",
  },
  {
    key: "markets",
    to: "/markets",
    textKey: "common.market",
    authRequired: true,
    isDisabled: false,
    icon: "markets",
  },
  {
    key: "my_profile",
    to: "/profile",
    textKey: "common.my_profile",
    authRequired: true,
    isDisabled: false,
    icon: "profile",
  },
  {
    key: "deposit",
    to: "/wallet/deposit",
    textKey: "common.deposit",
    authRequired: true,
    isDisabled: false,
    icon: "deposit",
  },
  {
    key: "withdrawal",
    to: "/wallet/withdrawal",
    textKey: "common.withdrawal",
    authRequired: true,
    isDisabled: false,
    icon: "withdrawal",
  },
  {
    key: "support_mobile",
    to: "/support",
    textKey: "common.support",
    authRequired: true,
    isDisabled: false,
    isSidebarAction: true,
    icon: "support",
  },
  {
    key: "settings",
    to: "/profile/settings",
    textKey: "seo.settings",
    authRequired: true,
    isDisabled: false,
    icon: "settings",
  },
];

export const NAV_ITEMS_SIDEBAR = [
  {
    key: "trading",
    to: MAIN_PAGE,
    textKey: "common.trading",
    authRequired: true,
    isDisabled: false,
    icon: "trading",
  },
  {
    key: "markets",
    to: "/markets",
    textKey: "common.market",
    authRequired: true,
    isDisabled: false,
    icon: "markets",
  },
  {
    key: "profile",
    to: "/profile",
    textKey: "common.profile",
    authRequired: true,
    isDisabled: false,
    icon: "profile",
  },
  {
    key: "finance",
    to: "/wallet",
    textKey: "common.finance",
    authRequired: true,
    isDisabled: false,
    icon: "finance",
  },

  {
    key: "support_mobile",
    to: "/support",
    textKey: "common.support",
    authRequired: true,
    isDisabled: false,
    isSidebarAction: true,
    icon: "support",
  },
];

export const IOS_APP_NAV_ITEM = {
  key: "ios_app",
  to: "/ios-app",
  textKey: "common.app_for_ios",
  authRequired: true,
  isDisabled: true,
  icon: "ios_app",
};

export const DESKTOP_VERSION_NAV_ITEM = {
  key: "desktop_version",
  textKey: "common.desktop_version",
  authRequired: true,
  isDisabled: true,
  icon: "desktop_version",
  isSidebarAction: true,
};

export const NAV_ITEMS_HEADER = [
  {
    key: "trade",
    to: MAIN_PAGE,
    textKey: "common.trade",
    authRequired: true,
    isDisabled: false,
  },
  {
    key: "markets",
    to: "/markets",
    textKey: "common.market",
    authRequired: true,
    isDisabled: false,
  },
  {
    key: "copytrade",
    to: "/copytrade",
    textKey: "common.copytrade",
    authRequired: true,
    isDisabled: true, // поки що недоступно
  },
  {
    key: "profile",
    to: "/profile",
    textKey: "common.profile",
    authRequired: true,
    isDisabled: false,
  },
  {
    key: "wallet",
    to: "/wallet/deposit",
    textKey: "common.wallet",
    authRequired: true,
    isDisabled: false,
  },
];
